import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";

const MessageModal = ({...props}) => {
    const {
        isOpen,
        toggle,
        centered,
        clickOutsideNotClose,
        type,
        message,
        messages
    } = props;
    const { t } = useTranslation("common");
    useEffect(() => {
        if (isOpen) {
        }
    }, [isOpen]);

    return (
        <Modal
            isOpen={isOpen}
            autoFocus={true}
            centered={centered}
            toggle={clickOutsideNotClose ? (() => {
            }) : toggle}
        >
            <div className="modal-content">
                <ModalHeader
                    toggle={toggle}>{t('message.notify')}</ModalHeader>
                <ModalBody>
                    {message?<div>
                        <label>
                            {type === 'infor' ?
                                <i className="dripicons-information text-success"> </i> :
                                (type === 'warning' ?
                                    <i className="dripicons-warning text-warning"> </i> :
                                    type === 'error' ?
                                        <i className="dripicons-wrong text-danger"> </i> : <></>)
                            }
                            {message}</label>
                    </div>:<></>}
                    {/* eslint-disable-next-line react/jsx-key */}
                    {messages?.map((item)=><div>
                        <label className={item.class}>
                            {type === 'infor' ?
                                <i className={"dripicons-information text-success " + item.class}> </i> :
                                (type === 'warning' ?
                                    <i className={"dripicons-warning text-warning " + item.class}> </i> :
                                    type === 'error' ?
                                        <i className={"dripicons-wrong text-danger " + item.class}> </i> : <></>)
                            }
                            {item.value}</label>
                    </div>)}
                </ModalBody>
                <ModalFooter>
                    <Row className="justify-content-end">
                        <Button
                            color="secondary"
                            className="btn-label"
                            type="button"
                            onClick={toggle}
                        >
                            <i className="bx bx-x label-icon"></i>
                            {t("button.close")}
                        </Button>
                    </Row>
                </ModalFooter>
            </div>
        </Modal>
    );
};

export default MessageModal;
